












































import { Component, Vue } from 'vue-property-decorator';
import meansPackageApi from '@/api/meansPackage';
import MainContent from './MainContent.vue';
import HeaderC from './HeaderC.vue';
import FooterC from './FooterC.vue';
import MainC from './MainC.vue';

import { Means, MeansReport } from './types';

@Component({
  components: {
    MainContent,
    HeaderC,
    FooterC,
    MainC,
  },
})
export default class MeansPackage extends Vue {
  means: Means = {
    title: '',
    content: [],
  }

  meansReport: MeansReport = {
    id: 0,
    reportIntervalTime: 5000,
    browserSource: '',
    leafKey: '',
  }

  timeId: any = ''

  allEssentialMaterialIsInvalid: Boolean = false

  jumpUrl: String = ''

  meansPackageStatus: Number = 1 // 0：待启用、1：启用中、2：已废弃

  get operatorSource(): String { // 区分销售和客户预览，若是销售预览，则不触发浏览（时长）、点赞事件
    const { operatorSource } = this.$route.query;
    return String(operatorSource || '');
  }

  get leafKey(): String {
    const { leafKey } = this.$route.query;
    return String(leafKey || '');
  }

  public async mounted() {
    await this.getMeansPackageDeatil();
    // 获取当前登录的网页 common：普通网页，wechat：微信网
    this.getbrowserSource();
    // 浏览事件上报 BD不进行上报
    if (this.operatorSource !== 'BD') {
      await this.eventReport('BROWSER_TIME', this.meansReport.browserSource, this.meansReport.leafKey);
      const {
        id, reportIntervalTime, browserSource, leafKey,
      } = this.meansReport;
      if (id && reportIntervalTime && browserSource && leafKey) this.reportTime();
      document.addEventListener('visibilitychange', this.documentIsHidden);
    }
  }

  destroy() {
    window.clearInterval(this.timeId);
  }

  documentIsHidden() {
    if (document.hidden === false) {
      window.clearInterval(this.timeId);
      const {
        id, reportIntervalTime, browserSource, leafKey,
      } = this.meansReport;
      if (id && reportIntervalTime && browserSource && leafKey) { this.reportTime(); }
    } else {
      window.clearInterval(this.timeId);
    }
  }

  // 资料包详细信息获取
  async getMeansPackageDeatil() {
    const { leafKey } = this;
    const { error, data }: ApiResponse.MDPData = await meansPackageApi.queryMeansPackageDeatil(leafKey);
    if (!error && data) {
      const meansPackage = data;
      this.means = {
        title: `${meansPackage.bizDesc || '您的'}美团充电宝招商报告`,
        content: meansPackage.relationList,
      };
      this.allEssentialMaterialIsInvalid = meansPackage.allEssentialMaterialIsInvalid;
      this.jumpUrl = meansPackage.jumpUrl;
      this.meansPackageStatus = meansPackage.status;
      this.meansReport.leafKey = meansPackage.leafKey;
      if ((meansPackage.status === 2 || meansPackage.allEssentialMaterialIsInvalid) && meansPackage.jumpUrl) {
        window.location.href = meansPackage.jumpUrl;
      }
    }
  }

  // 获取当前浏览器来源：【普通网页】【微信网页】
  getbrowserSource() {
    const source = window.navigator.userAgent.toLowerCase();
    // console.log(source);
    if (source.indexOf('micromessenger') !== -1) {
      this.meansReport.browserSource = 'wechat';
    } else {
      this.meansReport.browserSource = 'common';
    }
  }

  async eventReport(event: String, browserSource: String, leafKey: String, id?: Number) {
    const { error, data }: ApiResponse.MDPData = await meansPackageApi.meansPackageReport(event, browserSource, leafKey, id);
    if (!error && data && !id) {
      this.meansReport.id = data.id;
      this.meansReport.reportIntervalTime = data.reportIntervalTime * 1000;
    }
  }

  // 浏览时长定时上报事件
  reportTime() {
    const {
      id, reportIntervalTime, browserSource, leafKey,
    } = this.meansReport;
    this.timeId = setInterval(() => {
      this.eventReport('BROWSER_TIME', browserSource, leafKey, id);
    }, reportIntervalTime as number);
  }
}
